import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Auth, signInWithEmailAndPassword, onAuthStateChanged } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { ShopifyService } from './services/shopify.service';
import { TranslateService } from '@ngx-translate/core';
import { CognitoCredentialsService } from './services/cognito-credentials.service';
import { DesktopWarningComponent } from './desktop-warning/desktop-warning.component';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, DesktopWarningComponent, CookieBannerComponent],
})
export class AppComponent implements OnInit {

  private balkanCountries = [
    'AL', // Albania
    'BA', // Bosnia and Herzegovina
    'XK', // Kosovo
    'ME', // Montenegro
    'MK', // Macedonia
    'RS', // Serbia
  ];

  public isDesktop = false;

  constructor(
    private auth: Auth,
    private router: Router,
    private shopifyService: ShopifyService,
    private translate: TranslateService,
    private cognitoCredentialsService: CognitoCredentialsService
  ) {

    this.translate.setDefaultLang('mk');

    signInWithEmailAndPassword(this.auth, 'ecommerce@gulliguest.com', '4X9YvU5s')
      .then(() => {
      })
      .catch(error => {
        console.error('[AppComponent] Firebase login failed:', error);
      });

    onAuthStateChanged(this.auth, (user) => {
      if (user) {
      } else {
        console.warn('[AppComponent] User not authenticated');
        // Clear Cognito credentials cache on logout
        this.cognitoCredentialsService.clearCredentialsCache();
      }
    });

  }

  ngOnInit(): void {
    // Device detection: consider desktop if width >= 1024px
    this.isDesktop = window.innerWidth >= 1024;

    // Check if 'main' is cached in sessionStorage
    const cachedMain = sessionStorage.getItem('main');
    const cachedCountury = sessionStorage.getItem('country');

    const updateProductInfo = async () => {
      const countryCode = sessionStorage.getItem('country') || 'MK'; // fallback if not set
      return new Promise<void>((resolve, reject) => {
        this.shopifyService.getProductInfo('magnet', countryCode).subscribe({
          next: (result) => {
            const product = result?.data?.productByHandle;
            if (product) {
              let price = product.variants.edges[0].node;
              sessionStorage.setItem('price', JSON.stringify(price));
            } else {
              console.log('Product not found');
            }
            resolve(); // <-- Only resolve after data is set
          },
          error: (error) => {
            console.error('Error fetching product info:', error);
            // Still resolve to allow navigation even if product info fails
            // This prevents the navigation from hanging indefinitely
            resolve();
          }
        });
      });
    };

    if (cachedMain !== null) {
      this.shopifyService.setShopifyCredentials(cachedMain === 'true');
      this.translate.use(cachedCountury === 'MK' ? 'mk' : cachedCountury === 'DE' ? 'de' : 'en');
      updateProductInfo().then(() => {
          this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
      });
    } else {
      // Get country info
      fetch('https://ipinfo.io/json?token=2b1d4a4ee1f6be')
        .then(response => response.json())
        .then(data => {
          const country = data.country || 'MK';
          const isMain = this.balkanCountries.includes(country);
          const lang = country === 'MK' ? 'mk' : country === 'DE' ? 'de' : 'en';
          sessionStorage.setItem('main', isMain ? 'true' : 'false');  
          sessionStorage.setItem('country', country);
          sessionStorage.setItem('lang', lang);
          this.translate.use(lang);
          this.shopifyService.setShopifyCredentials(isMain);
          updateProductInfo().then(() => {
              this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
          });
        })
        .catch(error => {
          // Fallback to default values if IP info lookup fails
          const country = 'MK';
          const isMain = this.balkanCountries.includes(country);
          const lang = 'mk';
          sessionStorage.setItem('main', isMain ? 'true' : 'false');
          sessionStorage.setItem('country', country);
          sessionStorage.setItem('lang', lang);
          this.translate.use(lang);
          this.shopifyService.setShopifyCredentials(isMain);
          updateProductInfo().then(() => {
              this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
          });
        });
    }
  }
}



